import React, { Component, PropTypes } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';

import './projectsForm.scss';

import projectsStore from 'storeState/projects';
import generalStore from 'storeState/general';
import authStore from 'storeState/auth';
import usersStore from 'storeState/users';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import _ from 'lodash';

import FormField from 'views/formField/FormField';
import FormHeading from 'views/formHeading/FormHeading';
import FormButtons from 'views/formButtons/FormButtons';
import Button from 'views/button/Button';
import SelectList from 'views/selectList/SelectList';
import Select from "../select/Select";
import InternalLink from "../internalLink/InternalLink";
import URLService from "../../../service/URLService";

const defaultState = {
    inputName: "",
    selectedLocales: [],
    localeOptions: [],
    string_ids: {},
    parent_project_locale_ids: {},
    selectedUsers: [],
    usersOptions: [],
};

export class ProjectsForm extends Component {

    static contextTypes = {
        intl: PropTypes.object,
        project_id: PropTypes.string
    }

    constructor() {
        super();

        this.state = {
            ...defaultState
        }
    }

    componentWillMount() {

    }

    handleNameChange = (ev) => {
        this.setState({
            inputName: ev.target.value
        });
    }

    componentDidMount = () => {
        this.updateUsersOptions();
    }

    componentWillReceiveProps = (nextProps) => {
        if(nextProps.projects != this.props.projects || nextProps.project_id != this.props.project_id) {
            setTimeout(()=> {
                this.project = null;
                this.setState({
                    ...defaultState,
                    localeOptions: this.getLocaleOptions(this.props),
                    usersOptions: this.getUsersOptions(this.props)
                })

                if(nextProps.project_id) {
                    let project = _.find(nextProps.projects,(t) => {
                        return t.id==nextProps.project_id;
                    });
                    if(project) {
                        this.project = project;
                        const string_ids = {};
                        const parent_project_locale_ids = {};
                        _.forEach(this.project.locales, (l) => {
                            string_ids[l.locale_id] = l.project_locale_string_id;
                          parent_project_locale_ids[l.locale_id] = l.parent_project_locale_id;
                        });
                        this.setState({
                            inputName: this.project.name,
                            selectedLocales: _.map(this.project.locales, (l) => l.locale_id),
                            selectedUsers: this.project.users,
                            string_ids: string_ids,
                            parent_project_locale_ids: parent_project_locale_ids
                        });
                    }
                }
            })
        }

        if(nextProps.locales != this.props.locales) {
            setTimeout(() => {
                this.setState({ localeOptions: this.getLocaleOptions(nextProps) });
            });
        }

        if(nextProps.usersList != this.props.usersList) {
            setTimeout(() => {
                this.setState({ usersOptions: this.getUsersOptions(nextProps) });
            });
        }

        if(nextProps.currentTenantId != this.props.currentTenantId) {
            this.updateUsersOptions();
        }
    }

    getLocalesForSubmission = () => {
        return _.map(this.state.selectedLocales, (l) => {
            return {
                locale_id: l,
                string_id: this.state.string_ids[l] || _.find(this.props.locales, (o) => o.id==l).string_id,
                parent_project_locale_id: this.state.parent_project_locale_ids[l] || _.find(this.props.locales, (o) => o.id==l).parent_project_locale_id,
            }
        });
    }

    handleSaveButtonClick = () => {
        if(this.project) {
            this.props.actions.projectUpdateRequest({
                project_id: this.project.id,
                tenant_id: this.props.currentTenantId,
                project: {
                    name: this.state.inputName,
                    locales: this.getLocalesForSubmission(),
                    users: this.state.selectedUsers
                }
            });
        } else {
            this.props.actions.projectCreateRequest({
                tenant_id: this.props.currentTenantId,
                project: {
                    name: this.state.inputName,
                    tenant_id: this.props.currentTenantId,
                    locales: this.getLocalesForSubmission(),
                    users: this.state.selectedUsers
                }
            });
        }
    }

    handleDeleteButtonClick = () => {
        if(this.project) {
            this.props.actions.projectDeleteRequest({
                project_id: this.project.id,
                tenant_id: this.props.currentTenantId,
            });
        }
    }

    getLocaleOptions = (props) => {
        return _.map(props.locales, (l) => {
            return {
                value: l.id,
                label: "["+l.string_id+"] "+l.display_name
            }
        })
    }

    handleLocaleSelect = (val) => {
        this.setState({
            selectedLocales: [
                ...this.state.selectedLocales,
                val
            ]
        })
    }

    handleLocaleDelete = (val) => {
        this.setState({
            selectedLocales: _.filter(this.state.selectedLocales, (l) => l != val)
        })
    }

    handleStringIdChange = (locale_id, string_id) => {
        let stateChange = {
            string_ids: {
                ...this.state.string_ids,
            }
        };
        stateChange.string_ids[locale_id] = string_id;
        this.setState(stateChange);
    }

    handleFallbackLocaleChange = (locale_id, parent_project_locale_id) => {
      let stateChange = {
        parent_project_locale_ids: {
          ...this.state.parent_project_locale_ids,
        }
      };
      stateChange.parent_project_locale_ids[locale_id] = parent_project_locale_id;
      this.setState(stateChange);
    }

    renderSelectedLocaleRow = (id) => {
        const item = _.find(this.state.localeOptions, (o)=>o.value==id);
        const locale = _.find(this.props.locales, (o)=>o.id==id);
        const {formatMessage} = this.context.intl;
        console.log("this.state.string_ids[id]",this.state.string_ids[id]);
        console.log("this.state.string_ids",this.state.string_ids);
        console.log("id",id);
        console.log("this.state",this.state);
        console.log("this.project.locales",this.project ? this.project.locales : null);

        const stringid = this.state.string_ids[id];
        const parent_project_locale_id = this.state.parent_project_locale_ids[id];
        return (
          <div className="projects-form-locale-form">
              <div className="projects-form-locale-label">{item.label}</div>
              <div className="projects-form-locale-settings-line">
                  <input
                      className="projects-form-locale-stringid"
                      placeholder={locale.string_id}
                      onChange={(ev) => this.handleStringIdChange(id, ev.target.value)}
                      value={stringid}
                  />
                  <Select
                    placeholder={<FormattedMessage id="projectsForm.fallback.placeholder" defaultMessage="Fallback" />}
                    className={"projects-form-parent_project_locale_id"}
                    value={parent_project_locale_id}
                    options={this.project ? _.map(this.project.locales, (pl)=>{
                        return {
                          "value": pl.project_locale_id,
                          "label": pl.project_locale_string_id
                        }
                    }) : []}
                    onChange={(selectedOption) => this.handleFallbackLocaleChange(id, selectedOption ? selectedOption.value : null)}
                  />
              </div>
          </div>
        );
    }

    updateUsersOptions = (v) => {
        this.props.actions.usersListRequest({
            "tenant_id": this.props.currentTenantId
        });
    }

    getUsersOptions = (props) => {
        return _.map(props.usersList, (l) => {
            return {
                value: l.id,
                label: l.username
            }
        })
    }

    handleUserSelect = (val) => {
        this.setState({
            selectedUsers: [
                ...this.state.selectedUsers,
                val
            ]
        })
    }

    handleUserDelete = (val) => {
        this.setState({
            selectedUsers: _.filter(this.state.selectedUsers, (l) => l != val)
        })
    }

    onProjectClick = () => {
        URLService.gotoPush('/translations/'+this.project.id);
    }

    render() {

        console.log("this.project", this.project)

        return (
            <div className={`projects-form`}>

                <FormHeading>
                    <If condition={this.project}>
                        <span>
                            <FormattedMessage id="projectsForm.heading.editing" defaultMessage="Editing" />
                            &nbsp;
                            {this.project.name}
                        </span>
                    <Else />
                        <span>
                            <FormattedMessage id="projectsForm.heading.new" defaultMessage="New project" />
                        </span>
                    </If>
                </FormHeading>

                <FormField label={<FormattedMessage id="projectsForm.name.label" defaultMessage="Name" />}>
                    <input
                        type="text"
                        value={this.state.inputName}
                        onChange={this.handleNameChange}
                    />
                </FormField>

                <If condition={this.project}>
                    <div class={"button-bar"}>
                        <FormButtons>
                            <Button onClick={this.onProjectClick}>
                                <FormattedMessage id="projectsForm.translations.button" defaultMessage="Edit Translations" />
                            </Button>
                        </FormButtons>
                    </div>
                </If>

                <FormField label={<FormattedMessage id="projectsForm.locales.label" defaultMessage="Locales" />}>
                    <SelectList
                        options={this.state.localeOptions}
                        selected={this.state.selectedLocales}
                        onSelect={this.handleLocaleSelect}
                        onDelete={this.handleLocaleDelete}
                        rowRenderer={this.renderSelectedLocaleRow}
                    />
                </FormField>

                <FormField label={<FormattedMessage id="projectsForm.users.label" defaultMessage="Users" />}>
                    <SelectList
                        options={this.state.usersOptions}
                        selected={this.state.selectedUsers}
                        onSelect={this.handleUserSelect}
                        onDelete={this.handleUserDelete}
                    />
                </FormField>

                <FormButtons>
                    <If condition={this.project}>
                        <Button onClick={this.handleDeleteButtonClick}>
                            <FormattedMessage id="projectsForm.delete" defaultMessage="Delete" />
                        </Button>
                    </If>

                    <Button onClick={this.handleSaveButtonClick}>
                        <If condition={this.project}>
                            <FormattedMessage id="projectsForm.save.update" defaultMessage="Save" />
                        <Else />
                            <FormattedMessage id="projectsForm.save.new" defaultMessage="Create" />
                        </If>
                    </Button>
                </FormButtons>
            </div>
        );
    }
}


export default connect((state, props) => {
  return {
    projects: projectsStore.selectors.projectsList(state),
    locales: generalStore.selectors.locales(state),
    usersList: usersStore.selectors.usersList(state),
    currentTenantId: authStore.selectors.currentTenantId(state)
  }
},(dispatch, props) => {
  return {
    actions: bindActionCreators(Object.assign({}, projectsStore.actions, authStore.actions, usersStore.actions), dispatch)
  }
})(ProjectsForm)



// WEBPACK FOOTER //
// ./src/components/views/projectsForm/ProjectsForm.js